// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_sectionContainer__tyQ6w {
  position: relative;
  display: flex;
  min-width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
}

.styles_withLayoutVariants__3UyFq {
  transition: background-color 0.5s ease-out;
  cursor: pointer;
}
.styles_withLayoutVariants__3UyFq .styles_section__6cyHc {
  cursor: pointer;
}
.styles_withLayoutVariants__3UyFq:not(:hover) .styles_actionPanel__pZzzv {
  display: none;
}
.styles_withLayoutVariants__3UyFq:not(:hover) .styles_cancelPanel__BzfPx {
  display: none;
}
.styles_withLayoutVariants__3UyFq:hover {
  transition: background-color 0s ease-in-out;
  background-color: #e9ecef;
  z-index: 200;
}
.styles_withLayoutVariants__3UyFq:hover .styles_section__6cyHc {
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
}

.styles_highlighted__9J-tl {
  z-index: 100 !important;
}
.styles_highlighted__9J-tl .styles_section__6cyHc {
  opacity: 0.8;
  outline: 4px solid #00857C;
}

.styles_sectionStickyPanel__2Ndlr {
  z-index: 100;
  width: 2rem;
  min-width: 2rem;
  display: flex;
  flex-direction: column;
}
.styles_sectionStickyPanel__2Ndlr > div {
  position: sticky;
  top: 0;
  max-height: 3rem;
  flex-grow: 1;
}

.styles_section__6cyHc {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #fff;
  width: 100%;
}

.styles_actionPanel__pZzzv {
  top: 0.5rem;
  left: 1rem;
  position: absolute;
  display: flex;
  align-items: stretch;
  white-space: nowrap;
  border-radius: var(--bs-border-radius-sm);
}
.styles_actionPanel__pZzzv > * {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border: var(--bs-border-width) var(--bs-border-style) #ced4da;
  border-right-width: 0;
  border-left-width: 0;
}
.styles_actionPanel__pZzzv > *:last-child {
  border-right-width: var(--bs-border-width);
}
.styles_actionPanel__pZzzv > *:not(:first-child) {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.styles_actionPanel__pZzzv > *:not(:last-child) {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.styles_actionPanel__pZzzv .display-name {
  border: var(--bs-border-width) var(--bs-border-style) #ced4da !important;
  border-radius: var(--bs-border-radius-sm);
}
.styles_actionPanel__pZzzv button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
}
.styles_actionPanel__pZzzv button svg {
  height: 1em;
}

.styles_cancelPanel__BzfPx {
  top: 0.5rem;
  right: 1rem;
  position: absolute;
  white-space: nowrap;
}

.styles_buttonBg__vFZtB:hover {
  background-color: #e9ecef;
}`, "",{"version":3,"sources":["webpack://./src/components/Section/styles.module.scss","webpack://./src/styles/global-variables.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AAFF;;AAKA;EACE,0CAAA;EACA,eAAA;AAFF;AAIE;EACE,eAAA;AAFJ;AAMI;EACE,aAAA;AAJN;AAOI;EACE,aAAA;AALN;AASE;EACE,2CAAA;EACA,yBA/Bc;EAgCd,YCrBmC;ADcvC;AASI;EACE,+CAAA;AAPN;;AAYA;EACE,uBAAA;AATF;AAWE;EACE,YAAA;EACA,0BAAA;AATJ;;AAaA;EACE,YCrCyB;EDsCzB,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AAVF;AAYE;EACE,gBAAA;EACA,MAAA;EACA,gBAAA;EACA,YAAA;AAVJ;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AAXF;;AAkBA;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,yCAAA;AAfF;AAiBE;EACE,uBAAA;EACA,mBAAA;EACA,6DAAA;EACA,qBAAA;EACA,oBAAA;AAfJ;AAiBI;EACE,0CAAA;AAfN;AAkBI;EACE,oCAAA;EACA,uCAAA;AAhBN;AAmBI;EACE,qCAAA;EACA,wCAAA;AAjBN;AAqBE;EACE,wEAAA;EACA,yCAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AApBJ;AAsBI;EACE,WAAA;AApBN;;AA2BA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAxBF;;AA4BE;EACE,yBAxIc;AA+GlB","sourcesContent":["@use \"/home/runner/_work/gmc-dc-pbui-fe/gmc-dc-pbui-fe/src/styles/global-variables.scss\" as *;\n$CUSTOM_BG_COLOR: #e9ecef;\n\n.sectionContainer {\n  position: relative;\n  display: flex;\n  min-width: 100%;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: stretch;\n}\n\n.withLayoutVariants {\n  transition: background-color 0.5s ease-out;\n  cursor: pointer;\n\n  .section {\n    cursor: pointer;\n  }\n\n  &:not(:hover) {\n    .actionPanel {\n      display: none;\n    }\n\n    .cancelPanel {\n      display: none;\n    }\n  }\n\n  &:hover {\n    transition: background-color 0s ease-in-out;\n    background-color: $CUSTOM_BG_COLOR;\n    z-index: $zIndexSectionWithLayoutVariantsHover;\n\n    .section {\n      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);\n    }\n  }\n}\n\n.highlighted {\n  z-index:  $zIndexSectionHighlighted !important;\n\n  .section {\n    opacity: 0.8;\n    outline: 4px solid #00857C;\n  }\n}\n\n.sectionStickyPanel {\n  z-index: $zIndexSectionStickyPanel;\n  width: 2rem;\n  min-width: 2rem;\n  display: flex;\n  flex-direction: column;\n\n  >div {\n    position: sticky;\n    top: 0;\n    max-height: 3rem;\n    flex-grow: 1;\n  }\n}\n\n.section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  background: #fff;\n  width: 100%;\n}\n\n// ACTION PANEL\n\n$ACTION_PANEL_BORDER: #ced4da;\n\n.actionPanel {\n  top: .5rem;\n  left: 1rem;\n  position: absolute;\n  display: flex;\n  align-items: stretch;\n  white-space: nowrap;\n  border-radius: var(--bs-border-radius-sm);\n\n  &>* {\n    padding: .25rem .5rem;\n    font-size: .875rem;\n    border: var(--bs-border-width) var(--bs-border-style) $ACTION_PANEL_BORDER;\n    border-right-width: 0;\n    border-left-width: 0;\n\n    &:last-child {\n      border-right-width: var(--bs-border-width);\n    }\n\n    &:not(:first-child) {\n      border-top-left-radius: 0 !important;\n      border-bottom-left-radius: 0 !important;\n    }\n\n    &:not(:last-child) {\n      border-top-right-radius: 0 !important;\n      border-bottom-right-radius: 0 !important;\n    }\n  }\n\n  :global(.display-name) {\n    border: var(--bs-border-width) var(--bs-border-style) $ACTION_PANEL_BORDER !important;\n    border-radius: var(--bs-border-radius-sm);\n  }\n\n  button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: white;\n\n    svg {\n      height: 1em;\n    }\n  }\n}\n\n// CANCEL PANEL\n\n.cancelPanel {\n  top: .5rem;\n  right: 1rem;\n  position: absolute;\n  white-space: nowrap;\n}\n\n.buttonBg {\n  &:hover {\n    background-color: $CUSTOM_BG_COLOR;\n  }\n}","$navbarHeight: 50px;\n\n$clearSectionButtonColor: #6C757D;\n$clearAllButtonPrimary: #F8F9FA;\n$clearAllButtonDisabled: #A1BFBE;\n$borderColor: #dee2e6;\n\n$buttonBorderRadius: 3.2px;\n\n$buttonFontSize: 14px;\n\n$zIndexSimulationDisclaimer: 1000;\n$zIndexSectionWithLayoutVariantsHover: 200;\n$zIndexSectionHighlighted: 100;\n$zIndexSectionStickyPanel: 100;\n$zIndexModal: 100;\n$zIndexModalBackdrop: 10;\n$zIndexIconTitleTooltip: 2;\n$zIndexScreen: 2;\n$zIndexScreenBackdrop: 1;\n$zIndexLayoutPreviewListStickyPanel: 1;\n$zIndexTextCollectionsModalTh: 1;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionContainer": `styles_sectionContainer__tyQ6w`,
	"withLayoutVariants": `styles_withLayoutVariants__3UyFq`,
	"section": `styles_section__6cyHc`,
	"actionPanel": `styles_actionPanel__pZzzv`,
	"cancelPanel": `styles_cancelPanel__BzfPx`,
	"highlighted": `styles_highlighted__9J-tl`,
	"sectionStickyPanel": `styles_sectionStickyPanel__2Ndlr`,
	"buttonBg": `styles_buttonBg__vFZtB`
};
export default ___CSS_LOADER_EXPORT___;
